import { ResolveFn } from '@angular/router';
import { CommunityItem } from '../interfaces';
import { inject } from '@angular/core';
import { OUTLAW_QUERY_PARAMS } from '@outlaw/core';
import { catchError, map, of, switchMap } from 'rxjs';
import { CommunityNavigationService } from '../services';
import { PostService } from '../services/api/post.service';
import { PostExtenderService } from '../services/util/post-extender.service';

export const postResolver: (options?: { skipAuth?: boolean }) => ResolveFn<CommunityItem | null> =
  (options = {}) =>
  route => {
    const postService = inject(PostService);
    const postExtenderService = inject(PostExtenderService);
    const communityNavigationService = inject(CommunityNavigationService);

    const postId =
      route.queryParamMap.get(OUTLAW_QUERY_PARAMS.filmID) ||
      route.queryParamMap.get(OUTLAW_QUERY_PARAMS.postId) ||
      route.queryParamMap.get(OUTLAW_QUERY_PARAMS.post_id);

    if (!postId) {
      communityNavigationService.navigateToHome();
      console.log('no post id');
      return of(null);
    }

    return postService.getPost(postId, options).pipe(
      switchMap(post => {
        return postExtenderService.extendPosts([post]);
      }),
      map(([post]) => post),
      catchError(() => {
        communityNavigationService.navigateToHome();
        return of(null);
      })
    );
  };
